import { Component, OnInit } from '@angular/core';
import { ApiService } from '../utilities/services/api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { BaseService } from '@app/system/services/base.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { ApiService as ChannelsApiService } from '@app/modules/channels/utilitites/services/api.service';

@Component({
	selector: 'app-playlist-forms',
	templateUrl: './playlist-forms.component.html',
	styleUrls: ['./playlist-forms.component.scss']
})
export class PlaylistFormsComponent implements OnInit {

	action: 'addPlaylist' | 'editPlaylist' | 'addToPlaylist' | 'moderatePlaylist' | 'addPlaylistItem';
	formFields: any = [];
	config = { fxFlex: 100 };
	title;
	formObject;
	submitDisable = true;
	popupRef;
	currentUser;
	recordId;
	formPopup = true;
	playlistData;
	clearTimeout;
	list = [];
	pageNumber = 1;
	languageCode = 'en';
	limit = 100;
	resourceDetail;
	record;
	data;
	info = '';
	playlistFormObject;
	deviceDetails;
	selectedResources = [];
	visibilityField = [];
	formObjectData = {
		form: null,
		fields: []
	};

	constructor(
		private apiService: ApiService,
		public gfService: GlobalFunctionService,
		private globalApiService: GlobalApiService,
		public locale: LocaleService,
		private appInit: AppInitializerService,
		private popup: MatDialog,
		private resourceApiService: ResourceApiService,
		private baseService: BaseService,
		private deviceDevice: DetectDeviceService,
		private channelsApiService: ChannelsApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.deviceDevice.fingerPrint;
		if (!['addToPlaylist'].includes(this.action)) {
			this.baseService.formView = true;
		}
		if (this.action === 'addPlaylist' || this.action === 'editPlaylist') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('new_playlist');
			const title: TextBoxModel = {
				fieldColumn: 'title',
				fieldCaption: this.locale.translate('name'),
				additionalMetaData: {
					// maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					patternMatch: ''
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('name'),
				fieldOrder: 1
			};

			const description: TextAreaModel = {
				fieldColumn: 'description',
				fieldCaption: this.locale.translate('desc'),
				additionalMetaData: {
					maxChar: 500,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('desc'),
				fieldOrder: 2
			};

			// const makePublic: CheckBoxModel = {
			// 	fieldColumn: 'public',
			// 	fieldCaption: this.locale.translate('make_public'),
			// 	additionalMetaData: {
			// 		showLabel: false
			// 	},
			// 	fieldType: 'checkBox',
			// 	isHidden: false,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [
			// 		{
			// 			key: true,
			// 			value: this.locale.translate('make_public')
			// 		}
			// 	]
			// };
			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};
			if (this.action === 'editPlaylist') {
				this.title = this.locale.translate('edit_playlist');
				const headers: any = {
					lanCode: sessionStorage.getItem('locale') || 'en'
				};
				this.resourceApiService.detail(this.record.resourceID, headers).subscribe(
					(response) => {
						if (response) {
							title.value = response.title;
							description.value = response.description;
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						this.formFields = [title, description];
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.loadChannel(channel);
				this.formFields = [title, description];
				this.visibilityField = [channel];
				this.popupRef.componentInstance.popupLoader = false;
			}
			this.submitDisable = false;
		} else if (this.action === 'addToPlaylist') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('add_to_playlist');
			const headers = {};
			const params: any = {
				limit: this.limit,
				pageNumber: this.pageNumber,
				languageCode: this.languageCode
			};
			const resourceStatus = this.baseService.resourceStatus;
			for (const status of resourceStatus) {
				if (status.key === 'draft') {
					params.status = status.value;
				}
			}
			this.apiService
				.getList(params, headers)
				.subscribe(
					(response) => {
						if (response && response.hasOwnProperty('records')) {
							for (const data of response.records) {
								data.disable = false;
								// data.playListAdded = false;
								// if (data.infoFields.hasOwnProperty('resourceList') && this.resourceDetail) {
								// 	for (const resource of data.infoFields.resourceList) {
								// 		if (resource.resourceID === this.resourceDetail.resourceID) {
								// 			data.playListAdded = true;
								// 		}
								// 	}
								// }
								this.list.push(data);
							}
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
				.add(() => {
					this.submitDisable = false;
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else if (this.action === 'moderatePlaylist') {
			this.popupRef.componentInstance.popupLoader = true;

			this.title = this.locale.translate('moderation');
			this.info = this.locale.translate('this_require_moderation_but_your_not_workgroup_desc');
			const users: AutoCompleteModel = {
				fieldColumn: 'users',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('name'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('type_name'),
				isMultiple: true,
				options: [],
				selectedValue: [],
				preDefined: true
			};
			this.formFields = [
				users
			];
			if (this.data) {
				this.formObjectData = this.data.formObject;
			}
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} if (this.action === 'addPlaylistItem') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('add_resources');
			const title: AutoCompleteModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('type_title'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('type_title')
			};
			this.formFields = [title];
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		}

	}

	loadChannel(channelField) {
		channelField.options = [];
		const apiData = {};
		const headers: any = {};

		let selectedValue = [];
		if (channelField.selectedValue.length) {
			channelField.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push(items.key);
				}
			});
		}
		this.channelsApiService.getChannelList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.channelID)) {
								return items;
							}
						});
					}
					channelField.options = response.records.map((data) => {
						return {
							key: data.channelID,
							value: data.channelName
						};
					});
				}

			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		);
	}

	submit() {
		if (navigator.onLine) {
			if (this.action === 'addPlaylist' || this.action === 'editPlaylist') {
				this.checkPlaylist();
			} else if (this.action === 'moderatePlaylist') {
				this.saveModeratePlaylist();
			} else if (this.action === 'addPlaylistItem') {
				this.addPlaylistItem();
			} else {
				this.popupRef.close({ status: 'addPlaylist' });
			}
		}
	}

	removeResource(index) {
		if (navigator.onLine) {
			this.selectedResources.splice(index, 1);
		}
	}

	saveModeratePlaylist() {
		// this.savePlaylist([33])
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('people');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				let formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				let users = [];
				for (const data of formData.users) {
					if (data.isAdd && !data.isDelete) {
						users.push(data.key);
					}
				}
				this.savePlaylist(users);
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	addToPlaylist(data: any) {
		if (navigator.onLine) {
			data.disable = true;
			const apiData = {
				resourceID: [this.resourceDetail.resourceID]
			};
			const headers = {};
			data.deleting = true;
			this.apiService
				.addToPlaylist(apiData, data.resourceID, headers)
				.subscribe((response) => {
					if (response) {
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('resource_added_to_playlist'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					}
				},
					(error) => {
						if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
							error.error = this.locale.translate('resource_exists_in_playlist');
						}
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
				.add(() => {
					data.disable = false;
					data.deleting = false;
				});
		}
	}

	checkPlaylist() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('playlistAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				this.savePlaylist();
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}

	}

	savePlaylist(users = []) {
		// if (users.length > 0) {
		const headers: any = {};
		const apiValue: any = this.gfService.fieldSubmitApiValueConstruct(
			this.formObjectData.form.getRawValue(),
			this.formObjectData.fields
		);
		apiValue.languageCode = this.languageCode;
		apiValue.authors = [{ id: this.currentUser.userID }];
		const visibility: any = {};
		if (apiValue.channel) {
			const channelsID = [];
			for (const channel of apiValue.channel) {
				if (channel.isAdd && !channel.isDelete) {
					channelsID.push(channel.key);
				}
			}
			if (channelsID.length > 0) {
				visibility.channel = channelsID;
			}
		}
		delete apiValue.channel;
		if (Object.keys(visibility).length > 0) {
			apiValue.settings = {
				visibility
			};
		}
		// let status;
		// if (apiValue.public) {
		// 	status = apiValue.public[0];
		// }
		// if (apiValue.public && !apiValue.public[0]) {
		// 	apiValue.status = this.baseService.resourceStatus.find(items => items.key === 'draft').value;
		// }
		// delete apiValue.public;
		if (users && users.length) {
			apiValue.submittedTo = users[0];
		}
		apiValue.status = this.baseService.resourceStatus.find(items => items.key === 'draft').value;
		let msg = 'playlist_created';
		let method = this.apiService.savePlaylist(apiValue, headers);
		if (this.action === 'editPlaylist') {
			msg = 'playlist_updated';
			method = this.apiService.updatePlaylist(apiValue, this.record.resourceID, headers);
		} else {
			apiValue.notificationType = 1;
			if (this.deviceDetails.browserName === 'Safari') {
				apiValue.notificationType = 2;
			}
		}
		method.subscribe(
			(response) => {
				if (msg === 'playlist_created') {
					const userActivityData = {
						resourceID: (response) ? response.recordID : null,
						authors: [
							{
								userID: this.currentUser.userID
							}
						]
					};
					// this.gfService.blockHttpCall = false;
					this.baseService.logUserActivity('createplaylist', 'engagement', [''], { resourceData: userActivityData });
				}
				apiValue.status = status;
				this.popupRef.close(this.gfService.JSONMerge(apiValue, response));
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});

			},
			(error) => {
				if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'NOT_IN_WORKGROUP') {
					this.moderatePlaylist();

				}
				this.gfService.errorHandler(error, {
					alert: {
						id: 'playlistAlert'
					},
					form: this.formObjectData.form
				});
			}
		)
			.add(() => {
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});

		// } else {
		// 	this.moderatePlaylist();
		// }


	}

	moderatePlaylist() {
		this.baseService.formView = true;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PlaylistFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'moderatePlaylist'
					},
					{
						variableName: 'data',
						value: {
							formObject: this.formObjectData
						}
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		this.popupRef.close({ dialogRef });
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	addPlaylistItem() {
		if (this.selectedResources && this.selectedResources.length) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('playlistAlert');
			this.popupRef.componentInstance.popupLoader = true;
			const resourceID = [];
			const apiData: any = {};
			for (const resource of this.selectedResources) {
				resourceID.push(resource.resourceID);
			}
			if (resourceID.length > 0) {
				apiData.resourceID = resourceID;
			}
			this.apiService.addToPlaylist(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					this.popupRef.close(this.selectedResources);
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('resources_added'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
						error.error = this.locale.translate('the_resource_being_added_to_playlist_already');
					}
					this.gfService.errorHandler(error, {
						alert: {
							id: 'playlistAlert'
						},
						form: this.formObjectData.form
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else {
			this.gfService.errorHandler({ error: this.locale.translate('select_atleast_one_resource') }, {
				alert: {
					id: 'playlistAlert'
				}
			});
		}
	}

	formObjectReader(record: any) {
		if (record.form && record.form.controls.users) {
			const usersField = record.fields.find((items) => items.fieldColumn === 'users');
			let subscribe;
			record.form.controls.users.valueChanges.subscribe((controlResp) => {
				if (subscribe && !subscribe['closed']) {
					subscribe.unsubscribe();
				}
				if (this.clearTimeout) {
					clearTimeout(this.clearTimeout);
				}
				this.clearTimeout = setTimeout(() => {
					if (controlResp && typeof controlResp === 'string') {
						// const userFilter: any = { $and: [] };
						// const splitVal = controlResp.toLowerCase().split(' ');
						// for (const value of splitVal) {
						//   userFilter.$and.push({
						//     $or: {
						//       '$accountDetail.firstName$': { $substring: value },
						//       '$accountDetail.lastName$': { $substring: value }
						//     }
						//   });
						// }
						const apiData = {
							searchString: controlResp
						};
						const header: any = {};
						let selectedValue = [];
						if (usersField.selectedValue.length) {
							usersField.selectedValue.map(items => {
								if (items.isAdd && !items.isDelete) {
									selectedValue.push(items.key);
								}
							});
						}
						subscribe = this.globalApiService.getParentPublisher(apiData, header).subscribe(
							(response) => {
								if (response && response.records.length) {
									if (selectedValue.length) {
										response.records = response.records.filter(items => {
											if (!selectedValue.includes(items.userID)) {
												return items;
											}
										});
									}
									usersField.options = response.records.map((data) => {
										return {
											key: data.userID,
											value: `${data.firstName}${data.lastName
												? ' ' + data.lastName
												: ''}`,
											prefix: {
												type: 'image',
												value: data.profilePicURL
											},
											shortInfo: this.baseService.getUserShortInfo(data)
										};
									});
								} else {
									usersField.options = [];
								}
							},
							(error) => {
								this.gfService.errorHandler(error, {
									snackBar: {
										position: 'before'
									}
								});
								usersField.options = [];
							}
						);
					} else {
						usersField.options = [];
					}
				}, this.appInit.configuration.searchDelay);
			});
		}
		if (record.form && record.form.controls.hasOwnProperty('title') && this.action === 'addPlaylistItem') {
			let subscribe;
			const titleField = record.fields.find((items) => items.fieldColumn === 'title');
			record.form.controls.title.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					if (controlResp && typeof controlResp === 'object' && controlResp.isAdd) {
						this.addSelectedResource([controlResp.key]);
					}
					if (controlResp && typeof controlResp === 'object') {
						titleField.selectedValue = [];
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								reportType: 'FORPLAYLIST',
								resource: []
							};
							this.selectedResources.map(items => {
								apiData.resource.push(items.resourceID);
							});
							if (this.resourceDetail && this.resourceDetail.playlistData && this.resourceDetail.playlistData.length) {
								this.resourceDetail.playlistData.map(items => {
									apiData.resource.push(items.resourceID);
								});
							}
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							subscribe = this.globalApiService.searchByResource(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										titleField.options = [];
										for (const record of response.records) {
											titleField.options.push(
												{
													key: record,
													value: record.title
												}
											);
										}
									} else {
										titleField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									titleField.options = [];
								}
							);
						} else {
							titleField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (record.form && record.form.controls.channel) {
			let subscribe;
			const channelField = record.fields.find((items) => items.fieldColumn === 'channel');
			record.form.controls.channel.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (channelField.selectedValue.length) {
								channelField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.channelsApiService.getChannelList(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.channelID)) {
													return items;
												}
											});
										}
										channelField.options = response.records.map((data) => {
											return {
												key: data.channelID,
												value: data.channelName
											};
										});
									} else {
										channelField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									channelField.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								channelField.options = [];
							} else {
								this.loadChannel(channelField);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	addSelectedResource(resources) {
		for (const record of resources) {
			record.dragging = false;
			const data = record;
			data.read = false;
			data.resourceType = this.baseService.referenceType('resourceType', data.resourceTypeID);
			delete data.status;
			let finalData;
			if (data.resourceType) {
				if (data.resourceType.key === 'answer') {
					const cardData: QuestionCard = {
						title: data.title,
						date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: ''
					};
					if (data.authors && data.authors.length) {
						cardData.thumbnail = data.authors[0].profilePicURL;
						cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
							? ' ' + data.authors[0].lastName
							: ''}`;
						if (data.authors.length > 1) {
							cardData.usersCount = (data.authors.length - 1);
						}
					}
					finalData = cardData;
				} else if (['internalEvent', 'externalEvent'].includes(data.resourceType.key)) {
					const cardData: EventCard = {
						thumbnail: '',
						title: data.title,
						eventType: (data.resourceType && data.resourceType.key) ? data.resourceType.key : null
					};
					if (data.resourceType) {
						// if (data.infoFields) {
						// 	if (data.resourceType.key === 'internalEvent') {
						// 		if (data.infoFields.time) {
						// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
						// 		}
						// 		if (data.infoFields.date.length) {
						// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
						// 		}
						// 	} else {
						// 		if (data.infoFields.date) {
						// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
						// 		}
						// 	}
						// }
					}

					finalData = cardData;
				} else {
					const cardData: ContentImageCard = {
						removable: false,
						title: data.title,
						date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: '',
						type: data.resourceType.caption,
						read: data.read || false
					};
					finalData = cardData;
				}
			}
			if (data.resource.hasOwnProperty('duration')) {
				finalData.duration = data.resource.duration;
			}
			finalData.removable = true;
			let userID = null;
			if (data.authors && data.authors.length) {
				if (data.resourceType && ['knowledgeBead'].includes(data.resourceType.key)) {
					finalData.userThumbnail = data.authors[0].profilePicURL || '';
					finalData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
						? ' ' + data.authors[0].lastName
						: ''}`;
					if (data.authors.length > 1) {
						finalData.creator = `${finalData.creator} + ${data.authors.length - 1}`;
					}
				}
				userID = data.authors[0].userID;
			}
			finalData.userID = userID;
			if (data.stats && Object.keys(data.stats).length > 0 && data.settings) {
				if (data.settings.rating) {
					finalData.rating = data.stats.avgRating || 0;
				}
				if (data.settings.commenting) {
					finalData.commentsCount = data.stats.conversationCount || 0;
				}
			}
			if (data.resource && data.resource.thumbnail && data.resourceType && data.resourceType.key !== 'answer') {
				finalData.thumbnail = data.resource.thumbnail;
			}
			if (data.resourceFormat) {
				data.resourceFormat = this.baseService.referenceType('resourceFormat', data.resourceFormat);
				finalData.format = data.resourceFormat.key;
				if (finalData.thumbnail === '') {
					data.thumbnail = data.resourceFormat.image;
				}
			}
			if (data.resourceType && data.resourceType.key === 'answer') {
				delete data.description;
			}
			finalData.removable = true;
			finalData.watched = false;
			finalData.streaming = false;
			this.selectedResources.push(this.gfService.JSONMerge(finalData, data));
		}

	}

}
